import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-tip',
  templateUrl: './add-tip.component.html',
  styleUrls: ['./add-tip.component.less'],
})
export class AddTipComponent implements OnInit, OnDestroy {
  unsub: Subject<void>;
  loading = false;
  subTotal: number = 0; // Example subtotal, replace with actual value
  editForm: FormGroup = new FormGroup({
    isDollars: new FormControl(true),
    tipAmount: new FormControl(
      0,
      Validators.compose([Validators.required, Validators.min(0), Validators.maxLength(4)])
    ),
  });
  isNew: boolean;

  tipPercents = [5, 10, 15, 18, 20, 25, 30, 35];
  selectedTipPercent: number | null = null;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.unsub = new Subject();
    // If the user types a custom value, remove highlight
    this.editForm.valueChanges.subscribe(() => {
      if (this.selectedTipPercent !== null) {
        this.selectedTipPercent = null;
      }
    });
  }

  setTipFromPercent(percent: number) {
    this.selectedTipPercent = percent;
    // Update form so UI stays in sync
    this.editForm.patchValue(
      {
        isDollars: false,
        tipAmount: percent,
      },
      { emitEvent: false }
    ); // don't trigger valueChanges here
    this.sendTipToBackend(percent, false);
  }

  onSubmit() {
    const isDollars = this.editForm.value.isDollars;
    const tipValue = this.editForm.value.tipAmount;

    this.sendTipToBackend(tipValue, isDollars);
  }

  private sendTipToBackend(value: number, isDollars: boolean) {
    let tipAmountToSend = isDollars ? value : this.subTotal * (value / 100);

    const tipValues = {
      value: value,
      isDollars: isDollars,
      tipAmount: tipAmountToSend,
    };

    this.activeModal.close(tipValues);
  }

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}
